<template>
  <v-form @submit.prevent="onSubmit" ref="form">
    <v-row>
      <v-col cols="12" v-for="(item, i) in resource.items" :key="'item-'+i">
        <v-row>
          <v-col cols="12" md="6" class="py-0">
            <v-text-field v-model="item.origin" outlined dense :label="i18n['origin']" :disabled="item.wholesale_status_id > 3"
              :class="`${arabic ? 'arFont' : 'enFont'}`" :rules="[rules.required]" />
          </v-col>
          
          <v-col cols="12" md="6" class="py-0">
            <Field :field="countryField" :item="item" />
          </v-col>

          <v-col cols="12" md="6" class="py-0">
            <v-text-field v-model="item.quotation_quantity" outlined dense :label="i18n['quotation_quantity']" :disabled="item.wholesale_status_id > 3"
              :class="`${arabic ? 'arFont' : 'enFont'}`" />
          </v-col>
          <v-col cols="12" md="6" class="py-0">
            <v-text-field v-model="item.quotation_price" outlined dense :label="i18n['quotation_price']" :disabled="item.wholesale_status_id > 3"
              :class="`${arabic ? 'arFont' : 'enFont'}`" />
          </v-col>
          
          <v-col cols="12" md="6" class="py-0" v-for="(field, f) in fields" :key="'field-'+f">
            <Field :field="field" :item="item" :index="i" />
          </v-col>

          
          <v-col cols="12" :class="`${arabic ? 'arFont' : 'enFont'}`">
            <v-btn type="submit" color="success" v-if="resource.id">{{ i18n["update"] }}</v-btn>
            <v-btn type="submit" color="success" v-else>{{ i18n["po_submit"] }}</v-btn>
          </v-col>
          <v-col cols="12" :class="`${arabic ? 'arFont' : 'enFont'}`">
            <v-btn @click="onReset()" color="error" text class="mx-1" v-if="resource.id && item.wholesale_status_id > 3">{{ i18n["po_reset"] }}</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import Field from '@/components/Field.vue';
import { VueEditor } from "vue2-editor";

export default {
  components: {
    VueEditor,
    Field,
  },
  props: ['resource', 'statuses', 'countries'],
  data() {
    return {
      countryField: {
        name: "destination",
        label: 'destination',
        returnValue:'value',
        type: 'select',
        required:true,
        info: { en: '', ar: '' },
        data:[...this.$props.countries]
      },
      fields: [

        {
          name: "in_warehouse_date",
          type: 'date',
          label: 'in_warehouse_date',
          info: { en: '', ar: '' },
        },
        {
          name: "date_shipped_at",
          type: 'date',
          label: 'date_shipped_at',
          info: { en: '', ar: '' },
        },
        {
          name: "date_recieved_at",
          type: 'date',
          label: 'date_recieved_at',
          info: { en: '', ar: '' },
        },
        {
          name: "crm_po_key",
          type: 'text',
          label: 'crm_po_key',
          info: { en: '', ar: '' },
        },
        {
          name: "sku",
          type: 'text',
          label: 'product_sku',
          info: { en: '', ar: '' },
        },
        {
          name: "admin_note",
          type: 'textarea',
          label: 'admin_note',
          info: { en: '', ar: '' },
        },
        {
          name: "wholesale_status_id",
          type: 'select',
          returnValue:'id',
          label: 'status',
          data:[...this.$props.statuses],
          info: { en: '', ar: '' },
        },
        {
          name: "funding_percentage",
          type: 'text',
          label: 'funding_percentage',
          info: { en: '', ar: '' },
        },
        {
          name: "invoice_total",
          type: 'text',
          label: 'invoice_total',
          info: { en: '', ar: '' },
        },
        {
          name: "paid_total",
          type: 'text',
          label: 'paid_total',
          info: { en: '', ar: '' },
        },
        {
          name: "received_quantity",
          type: 'text',
          label: 'received_quantity',
          info: { en: '', ar: '' },
        },

      ],
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email'],
        url: value => /^(?:(?:https?:\/\/)?(?:www\.)?([a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,})|(?:www\.)?([a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}))(?:\/[^\s]*)?$/.test(value) || 'test'
      },
    }
  },
  computed: {
    language() {
      return this.$store.state.language;

    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar")
        return true;
    },
  },
  methods: {
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$emit('onSubmit')
      }
    },
    onReset() {
      this.$emit('resetApprovedPo')
    },
    getUpload(image) {
      console.log(image)
      this.resource.items[image.index].image = image.value
      
    },
    // async addNewServicePage() {
    //   if (this.$refs.form.validate()) {
    //     this.loading = true
    //     console.log(this.resouce)
    //     await this.$store.dispatch('putResource', { resource: `/purchase-orders/${this.resource.id}`, value: this.resource.items[0] })
    //     this.loading = false

    //     // this.$router.push('/purchase-orders')
    //   }
    // }
  },
}
</script>

<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";
</style>